import { render } from "./WatchAllMov.vue?vue&type=template&id=ba8734c0&scoped=true"
import script from "./WatchAllMov.vue?vue&type=script&lang=js"
export * from "./WatchAllMov.vue?vue&type=script&lang=js"

import "./WatchAllMov.vue?vue&type=style&index=0&id=ba8734c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba8734c0"]])

export default __exports__